<script lang="ts">
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import FontSizeDecorator, { type TextSize } from './Decorators/FontSizeDecorator.svelte';

  export let portableText: CustomBlockComponentProps<{ style: TextSize }>;
</script>

<p>
  <FontSizeDecorator size={portableText.value.style}>
    <slot />
  </FontSizeDecorator>
</p>

<style lang="scss">
  p {
    display: contents;
  }
</style>
